import { useState, useEffect } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import CustomDateInput from "@/components/desktop/form/input/input-date/CustomDateInput";
import ApplicationOrderBusinessCenter from "@/components/ApplicationOrder/BusinessCenter/ApplicationOrderBusinessCenter";

import { datetimeToLocale, dateToLocale } from "@/services/Utils";
import { useAppOrderCreate, useAppOrderCodeCreate } from "@/hooks/planning/application-order/applicationOrders";

import classes from "./createOrderApplication.module.scss";
import { rangeSelectorsValues } from "./createOrderApplication.constants";

const CreateAppOrderHead = ({ params, data, setData, calculateTotal }) => {
	const { data: response } = useAppOrderCreate(params);
	const { data: codeResponse, isLoading } = useAppOrderCodeCreate(data.estate_parent_id, data.app_order_id);

	const {
		business = [],
		estates_parents = [],
		estates = [],
		irrigations = [],
		business_centers_parents = [],
		business_centers = [],
		app_order_types = [],
		app_order_types_customer = [],
	} = response || {};

	const { customer } = useSelector((state) => state.auth.user);

	const [phenologicalStates, setPhenologicalStates] = useState([]);

	const [activeDetail, setActiveDetail] = useState(true);

	useEffect(() => {
		if ((response && response?.phenological_states.length === phenologicalStates.length) || phenologicalStates.length === 0) {
			setPhenologicalStates(response.phenological_states);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [response]);

	useEffect(() => {
		if (codeResponse && codeResponse.code && !data.app_order_id) {
			setData((prevData) => ({
				...prevData,
				code: codeResponse.code,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [codeResponse]);

	const handleChangeEstateParent = (estate_parent) => {
		let newData = { ...data };
		newData.items.map((item) => {
			item.dose_100L = "";
			item.dose_machinery = "";
			item.quantity = "";
			return item;
		});
		newData.estate_parent_id = estate_parent.value;
		newData.estate_id = "";
		newData.categories = [];
		newData.species = [];
		newData.varieties = [];
		newData.quarters = [];
		newData.business_centers = [];
		setData(newData);
	};

	const handleChangeEstate = (estate) => {
		let newData = { ...data };
		newData.items.map((item) => {
			item.dose_100L = "";
			item.dose_machinery = "";
			item.quantity = "";
			return item;
		});
		newData.estate_parent_id = estate.estate_parent_id;
		newData.estate_id = estate.value;
		newData.categories = [];
		newData.species = [];
		newData.varieties = [];
		newData.quarters = [];
		newData.business_centers = [];
		setData(newData);
	};

	const handleChangeIrrigation = (irrigations) => {
		let businessCentersParents = [];
		let businessCenter = [];

		irrigations.forEach((irrigation) => {
			let itemBusinessCentersParents = [];
			let itemBusinessCenter = irrigation.business_center.map((bc) => {
				bc.value = bc.business_center_id;
				bc.label = bc.name;
				bc.area = bc.total_ha ? String(bc.total_ha).replace(".", ",") : 0;
				bc.area_select = bc.ha ? String(bc.ha).replace(".", ",") : 0;

				if (bc.business_center_parent_id) {
					businessCentersParents.push(bc.business_center_parent_id);
				}

				return bc;
			});

			businessCentersParents = [...businessCentersParents, ...itemBusinessCentersParents];
			businessCenter = [...businessCenter, ...itemBusinessCenter];
		});

		let newIrrigation = {
			value: irrigations.map((irr) => irr.value),
		};

		handleChangeBusinessCenter(businessCenter, businessCentersParents, newIrrigation);
	};

	const handleApplicationOrderType = (type) => {
		let newData = { ...data };
		newData.application_order_type_id = type.value;
		newData.business_centers = [];
		setData(newData);
	};

	const handleApplicationOrderTypeCustomer = (type) => {
		let newData = { ...data };
		newData.application_order_type_id = type.application_order_type_id;
		newData.application_order_type_id_customer = type.value;
		newData.business_centers = [];
		setData(newData);
	};

	const handleChangeBusinessCenterParent = (business_center_parent) => {
		let businessCenterParent = [];
		business_center_parent.map((value) => businessCenterParent.push(value.value));

		const getBusinessCenter = business_centers
			.filter((bc) => businessCenterParent.includes(bc.business_center_parent_id))
			.map((bc) => ({
				...bc,
				area_select: bc.area ? String(bc.area).replace(".", ",") : 0,
			}));

		handleChangeBusinessCenter(getBusinessCenter, businessCenterParent);
	};

	const handleChangeBusinessCenter = (businessCenters, businessCentersParents = null, irrigation = null) => {
		let newData = { ...data };
		let newItems = [...data.items];

		if (businessCentersParents && customer.use_sectors) {
			newData.business_centers_parents = businessCentersParents;
		}
		if (irrigation) {
			newData.irrigation_id = irrigation.value;
		}

		newData.business_centers = businessCenters;
		newData.items = newItems.filter((item) => Boolean(item.isCopy) === false);

		calculateTotal({ newData });
	};

	const handleChangeDate = (index, value) => {
		setData({
			...data,
			application_order_date: value,
		});
	};

	const selectEstate = estates.find((e) => String(e.value) === String(data.estate_id));

	const selectBusinessCenter =
		Array.isArray(data.business_centers) && data.business_centers.length > 0 ? data.business_centers.map((bc) => bc.label || bc.name).filter(Boolean) : [];

	const colSize = customer?.use_code_oa ? 2 : 3;

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeDetail && "active"}>
				<Card.Header onClick={() => setActiveDetail(!activeDetail)} className={activeDetail && "active"}>
					Detalle
					<div>
						<span style={{ marginRight: "1em" }}>
							<strong> Campo: </strong>
							{selectEstate ? selectEstate.label : ""}
						</span>
						<span style={{ marginRight: "1em" }}>
							<strong> {customer.use_sectors ? "Sectores" : "Centro de Costo"}: </strong>
							{selectBusinessCenter.length > 0 ? selectBusinessCenter.join(", ") : ""}
						</span>
						<span style={{ marginRight: "1em" }}>
							<strong> Fecha: </strong>
							{` ${data ? dateToLocale(data.application_order_date) : ""}`}
						</span>
						<span>
							<strong> N° OA: </strong>
							{` ${data ? data.code : ""}`}
						</span>
					</div>
				</Card.Header>
				{activeDetail && (
					<Card.Body>
						<Row className={classes.header}>
							<Col md={12} sm={12}>
								<div className={classes.divInput}>
									<Row>
										<Col md={colSize}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Tipo OA</div>
												{app_order_types_customer.length === 0 ? (
													<Select
														placeholder={<div>Seleccione</div>}
														options={app_order_types.map((type) => ({
															value: type.value,
															label: type.label,
														}))}
														value={app_order_types
															.filter((type) => Number(type.value) === Number(data.application_order_type_id))
															.map((type) => ({
																value: type.id,
																label: type.label,
															}))}
														components={{ NoOptionsMessage }}
														onChange={handleApplicationOrderType}
													/>
												) : (
													<Select
														placeholder={<div>Seleccione</div>}
														options={app_order_types_customer.map((type) => ({
															value: type.value,
															label: type.label,
															application_order_type_id: type.application_order_type_id,
														}))}
														value={app_order_types_customer
															.filter((type) => Number(type.value) === Number(data.application_order_type_id_customer))
															.map((type) => ({
																value: type.id,
																label: type.label,
															}))}
														components={{ NoOptionsMessage }}
														onChange={handleApplicationOrderTypeCustomer}
													/>
												)}
											</div>
										</Col>
										<Col md={colSize}>
											{/* --------- Numero OA --------- */}
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Número OA</div>
												<div>
													<Form.Control
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																code: e.target.value,
															})
														}
														type="text"
														value={data.code ? data.code : ""}
														disabled={!data.application_order_type_id}
														placeholder={isLoading ? "Cargando número de OA..." : ""}
													/>
												</div>
											</div>
										</Col>
										{!!customer?.use_code_oa && (
											<Col md={colSize}>
												{/* --------- Código Interno--------- */}
												<div className={classes.inputForm}>
													<div className={classes.inputText}>Código Interno</div>
													<div>
														<Form.Control
															style={{
																padding: "6px",
															}}
															onChange={(e) =>
																setData({
																	...data,
																	internal_code: e.target.value,
																})
															}
															type="text"
															value={data.internal_code ? data.internal_code : ""}
														/>
													</div>
												</div>
											</Col>
										)}
										<Col md={3}>
											{/* --------- Razon Social --------- */}
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Razón Social</div>
												<div>
													<Select
														value={business && business.filter((b) => Number(b.value) === Number(data.business_id))}
														placeholder={<div>Seleccione</div>}
														options={business}
														onChange={(value) =>
															setData({
																...data,
																business_id: value.value,
															})
														}
														components={{ NoOptionsMessage }}
														isDisabled={!data.application_order_type_id}
													/>
												</div>
											</div>
										</Col>

										<Col md={3}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Estado Fenológico</div>
												<CreatableSelect
													value={phenologicalStates?.find(
														(o) => String(o.value) === String(data.application_orders_phenological_state_id),
													)}
													options={
														data.estate_id
															? phenologicalStates.filter((phenological_state) =>
																	phenological_state.estate_id
																		? String(phenological_state.estate_id)
																				.split(",")
																				.map((id) => id.trim())
																				.includes(String(data.estate_id))
																		: true,
																)
															: phenologicalStates.filter((phenological_state) => !phenological_state.estate_id)
													}
													menuPortalTarget={document.body}
													components={{ NoOptionsMessage }}
													formatCreateLabel={(value) => {
														return `Crear ${value}`;
													}}
													placeholder={<div>Seleccione</div>}
													onChange={(opt, meta) => {
														if (meta.action === "create-option") {
															let newOption = {
																value: meta.option.value,
																label: meta.option.label,
															};
															setPhenologicalStates([...phenologicalStates, newOption]);
														}

														setData({
															...data,
															application_orders_phenological_state_id: opt ? opt.value : "",
														});
													}}
													isDisabled={!data.application_order_type_id}
												/>
											</div>
										</Col>
										<Col md={3}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Fecha Ingreso</div>
												<div>
													<CustomDateInput
														value={data && data.application_order_date}
														setValue={handleChangeDate}
														disabled={!data.application_order_type_id}
													/>
												</div>
											</div>
										</Col>
										<Col md={3}>
											<Row>
												<Col md={6}>
													{/* --------- Hora Inicio ----------- */}
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Hora Inicio</div>
														<div>
															<Form.Control
																style={{
																	padding: "6px",
																}}
																onChange={(e) =>
																	setData({
																		...data,
																		start_time: e.target.value,
																	})
																}
																type="time"
																value={data.start_time}
																disabled={!data.application_order_type_id}
															/>
														</div>
													</div>
												</Col>
												<Col md={6}>
													{/* ---------------- Hora Fin ---------------- */}
													<div className={classes.inputForm}>
														<div className={classes.inputText}>Hora Fin</div>
														<div>
															<Form.Control
																style={{
																	padding: "6px",
																}}
																onChange={(e) =>
																	setData({
																		...data,
																		end_time: e.target.value,
																	})
																}
																type="time"
																value={data.end_time}
																disabled={!data.application_order_type_id}
															/>
														</div>
													</div>
												</Col>
											</Row>
										</Col>
										<Col md={2}>
											{/* --------- Temperatura --------- */}
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Temperatura °C: {data.temperature && data.temperature}</div>
												<div>
													<Form.Control
														min={rangeSelectorsValues.minTemp}
														max={rangeSelectorsValues.maxTemp}
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																temperature: e.target.value,
															})
														}
														type="range"
														value={data.temperature ? data.temperature : ""}
														disabled={!data.application_order_type_id}
													/>
												</div>
											</div>
										</Col>
										<Col md={2}>
											{/* --------- Viento --------- */}
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Viento Km/hr: {data.wind && data.wind}</div>
												<div>
													<Form.Control
														min={rangeSelectorsValues.minWind}
														max={rangeSelectorsValues.maxWind}
														style={{
															padding: "6px",
														}}
														onChange={(e) => {
															setData({
																...data,
																wind: e.target.value,
															});
														}}
														type="range"
														value={data.wind ? data.wind : ""}
														disabled={!data.application_order_type_id}
													/>
												</div>
											</div>
										</Col>
										<Col md={2}>
											{/* --------- Humedad --------- */}
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Humedad %HR: {data.wetness && data.wetness}</div>
												<div>
													<Form.Control
														min={rangeSelectorsValues.minWetness}
														max={rangeSelectorsValues.maxWetness}
														style={{
															padding: "6px",
														}}
														onChange={(e) =>
															setData({
																...data,
																wetness: e.target.value,
															})
														}
														type="range"
														value={data.wetness ? data.wetness : ""}
														disabled={!data.application_order_type_id}
													/>
												</div>
											</div>
										</Col>
									</Row>
								</div>
							</Col>

							<Col md={12} sm={12} style={{ borderTop: "1px solid #f2f2f2" }}>
								<div className={classes.divInput}>
									<Row>
										{!!customer.use_estates_parents && (
											<Col md={3}>
												<div className={classes.inputForm}>
													<div className={classes.inputText}>Campo</div>
													<Select
														placeholder={<div>Seleccione</div>}
														options={estates_parents}
														value={estates_parents.filter(
															(estate_parent) => Number(estate_parent.value) === Number(data.estate_parent_id),
														)}
														onChange={handleChangeEstateParent}
														components={{ NoOptionsMessage }}
														isDisabled={!data.application_order_type_id}
													/>
												</div>
											</Col>
										)}

										<Col md={3}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>Bodegas</div>
												<Select
													placeholder={<div>Seleccione</div>}
													options={
														data.estate_parent_id ? estates.filter((e) => e.estate_parent_id === data.estate_parent_id) : estates
													}
													value={estates.filter((estate) => Number(estate.value) === Number(data.estate_id))}
													onChange={handleChangeEstate}
													components={{ NoOptionsMessage }}
													isDisabled={!data.application_order_type_id}
												/>
											</div>
										</Col>

										{Number(data.application_order_type_id) === 2 && (
											<Col md={3}>
												<div className={classes.inputForm}>
													<div className={classes.inputText}>Sector de Riego</div>
													<Select
														isMulti
														placeholder={<div>Seleccione</div>}
														options={
															data.estate_id
																? irrigations.filter(
																		(irrigation) =>
																			Array.isArray(irrigation.estates_ids) &&
																			irrigation.estates_ids.includes(Number(data.estate_id)),
																	)
																: []
														}
														value={
															data.irrigation_id
																? irrigations.filter((irrigation) =>
																		data.irrigation_id.map((irr) => Number(irr)).includes(Number(irrigation.value)),
																	)
																: []
														}
														onChange={handleChangeIrrigation}
														components={{ NoOptionsMessage }}
														isDisabled={!data.application_order_type_id}
													/>
												</div>
											</Col>
										)}
										{!!customer.use_sectors && (
											<Col md={3}>
												<div className={classes.inputForm}>
													<div className={classes.inputText}>Centro de Costo</div>
													<div>
														<Select
															isMulti
															value={business_centers_parents?.filter(
																(business_center_parent) =>
																	data.business_centers_parents.includes(Number(business_center_parent.value)) &&
																	Number(business_center_parent.estate_id) === Number(data.estate_id),
															)}
															placeholder={<div>Seleccione</div>}
															options={
																business_centers_parents
																	? business_centers_parents.filter(
																			(business_center_parent) =>
																				Number(business_center_parent.estate_id) === Number(data.estate_id),
																		)
																	: []
															}
															onChange={handleChangeBusinessCenterParent}
															components={{ NoOptionsMessage }}
															isDisabled={!data.application_order_type_id || Number(data.application_order_type_id) === 2}
														/>
													</div>
												</div>
											</Col>
										)}
									</Row>
									{![3].includes(data.application_order_type_id) && (
										<ApplicationOrderBusinessCenter
											handleChangeBusinessCenter={handleChangeBusinessCenter}
											businessCenters={business_centers
												.filter((bc) =>
													!customer.use_sectors
														? String(bc.estate_id).split(",").map(Number).includes(Number(data.estate_id))
														: data.business_centers_parents.includes(Number(bc.business_center_parent_id)),
												)
												.map((bc) => ({
													value: bc.value,
													label: bc.label,
													specie: bc.specie,
													variety: bc.variety,
													area: bc.area ? String(bc.area).replace(".", ",") : 0,
													area_select: bc.area ? String(bc.area).replace(".", ",") : 0,
												}))}
											selectedBusinessCenter={
												Array.isArray(data.business_centers) && data.business_centers.length > 0
													? data.business_centers // Ya son objetos completos del backend
													: []
											}
											estateParent={data.estate_parent_id}
										/>
									)}{" "}
									<Row>
										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>
													{data && data.approver && "Aprobador"}
													{data && data.rejecter && "Rechazador"}
												</div>
												<div>
													{data && data.approver && data.approver}
													{data && data.rejecter && data.rejecter}
												</div>
											</div>
										</Col>

										<Col md={6}>
											<div className={classes.inputForm}>
												<div className={classes.inputText}>
													{data && data.date_approved && "Fecha Aprobación"}
													{data && data.date_reject && "Fecha Rechazo"}
												</div>
												<div>
													{data && data.date_approved && datetimeToLocale(data.date_approved)}
													{data && data.date_reject && datetimeToLocale(data.date_reject)}
												</div>
											</div>
										</Col>
									</Row>
								</div>
							</Col>

							<Col md={12} sm={12}>
								<div className={classes.inputForm}>
									<div className={classes.inputText}>Observaciones</div>
									<div>
										<Form.Control
											style={{
												padding: "6px",
											}}
											onChange={(e) =>
												setData({
													...data,
													observations: e.target.value,
												})
											}
											as="textarea"
											rows={3}
											value={data.observations ? data.observations : ""}
											disabled={!data.application_order_type_id}
										/>
									</div>
								</div>
							</Col>
						</Row>
					</Card.Body>
				)}
			</Card>
		</Col>
	);
};

export default CreateAppOrderHead;
